import React, { useState, useEffect } from "react";
import SuggestedPromptCards from "../SuggestedPromptCards/SuggestedPromptCards";
import ToggleDictation from "../DictationButton/ToggleDictation";
import PreviewCard from "../PreviewCard/PreviewCard";
import { DropDownSelector } from "../DropDownSelector/DropDownSelector";
import SubmitGeneration from "./SubmitGeneration";

// Import images
import Comic from "../../images/comic.png";
import Digital from "../../images/digital.png";
import Gothic from "../../images/gothic.png";
import Impressionism from "../../images/impressionism.png";

const PromptInputContainer = ({
  children,
  setIdeaInputText,
  interimTranscript,
  setInterimTranscript,
  isListening,
  setIsListening,
  onPresetPromptClick,
  generatedImageUrl,
  isLoading,
  handleChange,
  ideaInputText,
  showNotification,
  inputRef,
  setAlertOptions,
  setIsLoading,
  setIsVideo,
  setVideoOptions,
  videoOptions,
  dropDownOptions,
  setDropDownOptions,
}) => {
  const [showPlaceholder, setShowPlaceholder] = useState(true);

  useEffect(() => {
    setShowPlaceholder(ideaInputText.length === 0);
  }, [ideaInputText]);

  const handleDictationTextChange = (text) => {
    setIdeaInputText((prevText) => prevText + (prevText ? " " : "") + text);
  };

  const selectOption = (option, type) => {
    setDropDownOptions((prev) => ({ ...prev, [type]: option }));
  };

  const showAllLengthOptions = false; // Set this to true to show all options

  return (
    <div className="flex flex-col items-center w-full max-w-[700px] mx-auto p-2.5box-border">
      <SuggestedPromptCards onPromptClick={onPresetPromptClick} />
      <div className="w-full flex flex-col gap-5">
        <div className="relative w-full">
          <div className="relative">
            {showNotification && (
              <div className="absolute top-[-2.5rem] left-1/2 transform -translate-x-1/2 bg-black bg-opacity-70 text-white p-2 rounded text-sm z-50 animate-fadeInOut">
                Character limit reached
              </div>
            )}
            <textarea
              ref={inputRef}
              id="story-prompt"
              name="storyPrompt"
              rows="5"
              placeholder="Request anything you want."
              autoFocus
              onChange={handleChange}
              value={`${ideaInputText}${interimTranscript}`}
              maxLength={700}
              className={`w-full p-2.5 box-border resize-vertical min-h-[60px] rounded bg-[#2e2e2e] text-[#e6e6e6] border border-[#4a4a4a] text-xl font-roboto transition-all duration-300 ease-in-out focus:outline-none focus:border-[#8e6bc2] focus:shadow-[0_0_0_2px_rgba(161,121,222,0.2)] ${
                generatedImageUrl ? 'pr-32 xl:pr-36 2xl:pr-44' : 'pr-15'
              } placeholder-transparent`}
            ></textarea>
            {showPlaceholder && (
              <div className="absolute top-0 left-0 p-2.5 pointer-events-none text-[#9ca3af] text-xl font-roboto">
                Request <span className="text-shadow-custom">anything</span> you want.
              </div>
            )}
            <div className="absolute bottom-[15px] left-[10px] z-10 w-6 h-6 flex items-center justify-center cursor-pointer pb-[5px]">
              <ToggleDictation
                onTextChange={handleDictationTextChange}
                interimText={interimTranscript}
                setInterimText={setInterimTranscript}
                setIsListening={setIsListening}
                isListening={isListening}
              />
            </div>
            <PreviewCard imageUrl={generatedImageUrl} isLoading={isLoading} className="absolute bottom-2.5 right-2.5 z-10" />
          </div>
        </div>
        {/* <div className={style.controlsWrapper}> */}
        <div className="flex flex-col gap-5">
          <div className="flex justify-between w-full mt-2.5">
            {[
              {
                type: "style",
                label: "Visuals",
                options: [
                  { name: "Digital", img: Digital },
                  { name: "Comic", img: Comic },
                  { name: "Gothic", img: Gothic },
                  { name: "Painterly", img: Impressionism },
                ],
                gallery: true,
              },
              {
                type: "mode",
                label: "Presets",
                options: [
                  { name: "Tovera" },
                  { name: "Mini-Doc" },
                  { name: "Bizarre" },
                  { name: "Thought-provoking" },
                  { name: "Black-Mirror" },
                  { name: "Unhinged" },
                  { name: "Alan Watts" },
                  { name: "Horror" },
                  { name: "Buddhist Monk" },
                ],
              },
              {
                type: "length",
                label: "Length",
                options: [
                  { name: "Auto" },
                  { name: "Short" },
                  { name: "Medium" },
                  { name: "Extended" },
                  { name: "Extended+" },
                ],
              },
              {
                type: "voice",
                label: "Voice",
                options: [{ name: "Male" }],
              },
            ].map(({ type, label, options, gallery }) => (
              <DropDownSelector
                key={type}
                label={label}
                onClickFunction={selectOption}
                selectList={options}
                text={dropDownOptions[type]}
                type={type}
                gallery={gallery}
              />
            ))}
          </div>
          <SubmitGeneration
            ideaInputText={ideaInputText}
            dropDownOptions={dropDownOptions}
            setAlertOptions={setAlertOptions}
            setIsLoading={setIsLoading}
            setIsVideo={setIsVideo}
            setVideoOptions={setVideoOptions}
            videoOptions={videoOptions}
          />
        </div>
        {children}
      </div>
    </div>
  );
};

export default PromptInputContainer;
